import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import SettingFieldTable from '@/views/mixin/SettingFieldTable';
import MesTable from '@/api/MesTable/index.js';
import fastSearch from '@/components/fast-search';
import util from '@/libs/util';
import { DeleteOneById, ExportListData } from '@/api/DnbarcodeHandmade';
import ExportListMixin from '@/views/mixin/ExportList';
var mesTable = MesTable('DnbarcodeHandmade/LoadData');
export default {
  mixins: [SettingFieldTable({
    defaultLoadDataApi: function defaultLoadDataApi(e) {
      return mesTable.LoadData(e);
    }
  }), ExportListMixin],
  components: {
    fastSearch: fastSearch
  },
  data: function data() {
    return {
      mainTable: [],
      code: '',
      formData: {
        Page: 1,
        // 当前页
        Limit: 10,
        // 分页大小
        Data: {
          VENDOR_CODE: util.getVENDOR_CODE(),
          ORGANIZE_ID: util.cookies.get('ORG_ID')
        }
      },
      pageInfo: {
        TotalCount: 1,
        PageSize: 10,
        PageIndex: 1
      },
      loading: false,
      times: []
    };
  },
  created: function created() {
    this.getLoadData();
  },
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/DnbarcodeHandmadeOutBox', ['setOrderStatu'])), {}, {
    // 日期选择
    handleDate: function handleDate() {
      if (this.times !== null) {
        this.formData.Data.START_TIME = this.times[0];
        this.formData.Data.END_TIME = this.times[1];
        this.getLoadData();
      } else {
        this.formData.Data.START_TIME = null;
        this.formData.Data.END_TIME = null;
        this.getLoadData();
      }
    },
    // 搜索
    search: function search() {
      this.formData.Page = this.pageInfo.PageIndex;
      this.getLoadData();
    },
    // 点击导出
    handelExportListData: function handelExportListData() {
      var ORGANIZE_ID = util.cookies.get('ORG_ID');
      var Page = this.pageInfo.PageIndex;
      var Limit = this.pageInfo.PageSize;
      var LIST_ROUTE = '/DeliveryNote/DnbarcodeHandmadeOutBox';
      var EXPORT_FILE_NAME = '手工打码外箱列表';
      this.setUnreadExportMessionNum();
      ExportListData({
        ORGANIZE_ID: ORGANIZE_ID,
        Page: Page,
        Limit: Limit,
        LIST_ROUTE: LIST_ROUTE,
        EXPORT_FILE_NAME: EXPORT_FILE_NAME
      }); // console.log('导出res', res)
      // if (res.code === 0) {
      //   window.open(this.$store.getters.getVUE_APP_DOWN + res.data)
      // } else {
      //   this.$message.warning('导出失败')
      // }
    },
    handleCurrentChange: function handleCurrentChange(index) {
      this.formData.Page = index;
      this.getLoadData();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.formData.Limit = size;
      this.getLoadData();
    },
    // 删除
    handelDelete: function handelDelete(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(row);

                _this.$confirm('确定要删除?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return DeleteOneById(row.ID);

                        case 2:
                          res = _context.sent;

                          if (res.code === 0) {
                            _this.$message.success('删除成功');

                            _this.getLoadData();
                          } else {
                            _this.$message.warning(res.message);
                          }

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))).catch(function () {
                  _this.$message.warning('已取消');
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 点击查看
    handelEdit: function handelEdit(row) {
      this.setOrderStatu('orderShow');
      this.$emit('onHandleEdit', row);
    },
    // 新增外箱标签打码订单
    handelAddBtn: function handelAddBtn() {
      this.setOrderStatu('addOrder');
    },
    getLoadData: function getLoadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.loading = true;
                _context3.next = 3;
                return mesTable.LoadData(_this2.formData);

              case 3:
                res = _context3.sent;
                _this2.loading = false;
                console.log('手工打码list res', res);

                if (res.code === 0) {
                  _this2.mainTable = res.data.Items;
                  _this2.pageInfo.TotalCount = res.data.TotalCount;
                  _this2.pageInfo.PageSize = res.data.PageSize;
                  _this2.pageInfo.PageIndex = res.data.PageIndex;
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    fastSearch: function fastSearch(searchData) {
      // console.log('searchData',searchData);
      this.formData.ParamList = this.mergeParamList(searchData.ParamList, this.formData.ParamList);
      this.getLoadData();
    }
  })
};